// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'FrederickSimms', 'FrederickSimms Fallback', Objektiv, sans-serif"},"className":"__className_7dc01f","variable":"__variable_7dc01f"};